import gql from 'graphql-tag'

import PageSliderBlock from '@Queries/cms/fragments/blockFragments/PageSliderBlock.fragment'
import ProductListBlock from '@Queries/cms/fragments/blockFragments/ProductListBlock.fragment'
import RecommendedProducts from '@Queries/cms/fragments/RecommendedProducts.fragment'

export default gql`
  ${PageSliderBlock}
  ${ProductListBlock}
  ${RecommendedProducts}

  fragment BlockAppearanceFragment on BlockAppearance {
    asset {
      ...ReferenceContent
    }
    backgroundColor
    textColor
    extraColors
    font
  }

  fragment ElementsContent on Elements {
    id
    alignment
    position
    stackingMode
    items {
      __typename
      ... on ElementButton {
        id
        text
        style
        reference {
          ...ReferenceContent
        }
        appearance {
          ...BlockAppearanceFragment
        }
      }
      ... on ElementChip {
        id
        text
        reference {
          ...ReferenceContent
        }
        appearance {
          ...BlockAppearanceFragment
        }
      }
      ... on ElementLabel {
        id
        text
        reference {
          ...ReferenceContent
        }
        appearance {
          ...BlockAppearanceFragment
        }
      }
      ... on ElementTypography {
        id
        text
        htmlElement
        style
        appearance {
          ...BlockAppearanceFragment
        }
      }
      ... on ElementTypographyRTE {
        id
        rte {
          key
          value
        }
        appearance {
          ...BlockAppearanceFragment
        }
      }
    }
  }

  fragment BlockLinkFragment on Link {
    id
    image {
      url
    }
    imageMobile {
      url
    }
    url
    newTab
    queryParameters
    references {
      ... on Page {
        id
        type
        title
      }
    }
  }

  fragment BlockRTEFieldFragment on RTEField {
    __typename
    key
    referencesWithKey {
      key
      reference {
        ...ReferenceContent
      }
    }
    value
  }

  fragment BlockContent on IBlock {
    __typename
    id
    type
    title
    splitTest {
      test
      groups
    }
    appearance {
      ...BlockAppearanceFragment
    }
    common {
      chips {
        appearance {
          ...BlockAppearanceFragment
        }
        link {
          ...BlockLinkFragment
        }
      }
      label {
        appearance {
          ...BlockAppearanceFragment
        }
        text {
          ...WordbookFragment
        }
      }
      position
      status
      title
      titleElement
      text {
        value
      }
      settings
    }
    settings
    ... on IWithFields {
      fields {
        ...Fields
      }
    }
    ... on AccordionListBlock {
      __typename
      accordions {
        title
        fields {
          ...Fields
        }
      }
    }
    ... on ActiveCampaignBlock {
      __typename
      description {
        ...BlockRTEFieldFragment
      }
      highlightText
    }
    ...PageSliderBlock
    ... on GalleryBlock {
      __typename
      slides {
        __typename
        images {
          id
          url
          mobileURL
          captionOptions {
            caption
            references {
              ... on Page {
                __typename
                type
                id
                fields {
                  ... on ProductField {
                    __typename
                    key
                    product(mode: PROJECTION, combineVariants: true, onlyEnabled: true, sortVariants: true) {
                      ...ProductContent
                    }
                  }
                }
              }
            }
          }
          fields {
            ...FieldContent
          }
        }
        fields {
          ...Fields
        }
      }
    }
    ... on InfoPanelBlock {
      __typename
      infoPanels {
        icon {
          ...ReferenceContent
        }
        title {
          ...WordbookFragment
        }
        subTitle {
          ...WordbookFragment
        }
        text {
          ...WordbookFragment
        }
      }
    }
    ... on LookDisplayBlock {
      asset {
        ...ReferenceContent
      }
      products {
        product(mode: PROJECTION, combineVariants: true, onlyEnabled: true, sortVariants: true) {
          ...RecommendedProducts
        }
        x
        y
      }
    }
    ... on PageGridBlock {
      columns
      references {
        __typename
        ... on Page {
          id
          type
          url
          brand {
            id
            logo
            title
          }
          openGraph {
            title
            description
            imageURL
          }
        }
      }
      showDescription
      titlePosition
    }
    ...ProductListBlockFragment
    ... on ProductSliderBlock {
      facetFilters
      filter
      filters
      header
      limit
      sorting
    }
    ... on USPBlock {
      __typename
      asset {
        ...ReferenceContent
      }
      items {
        id
        link {
          key
          url
          newTab
          references {
            __typename
            ... on Page {
              id
              type
              title
            }
          }
        }
        linkTitle
        title
        text {
          ...BlockRTEFieldFragment
        }
      }
    }
  }
`
